import { render } from "./HeroiconsOutlineStatusOffline.vue?vue&type=template&id=0bc24284"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineStatusOffline.vue"]])

export default __exports__